import { Component, OnInit, Input } from '@angular/core';
import { Settings, AppSettings } from '../../../app.settings';
import { PageContentService } from 'src/services/pagecontent.service';

@Component({
    selector: 'app-currency',
    templateUrl: './currency.component.html',
    styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit {
    @Input() dividers: boolean = true;
    @Input() iconSize: string = 'sm';
    @Input() iconColor: string = '';
    public currencies = ['USD', 'EUR'];
    public currency: any;
    public settings: Settings;
    public skiptocontent: any;
    public siteConfigList: any[];
    public isSkiptomainContent :boolean;
    constructor(public appSettings: AppSettings,public pageservice: PageContentService) {
        this.settings = this.appSettings.settings;
    }

    ngOnInit() {
        this.currency = this.settings.currency;
        this.getSiteConfig();
        //this.skiptocontent = this.settings.isSkipToMainContent;
    }

    public changeCurrency(currency) {
        alert(currency);
        this.currency = currency;
        this.settings.currency = currency;
    }

    skiptomaincontentChange(event) {
        
        this.skiptocontent = event.value;
        this.settings.isSkipToMainContent = true;
        // console.log('Selected skip to contnet :' + this.settings.isSkipToMainContent);
        //this.broadcastMessageService.sendMessage(event.value);
    }

    getSiteConfig() {
        this.pageservice.getSiteconfig().subscribe(result => {
            
            if (result != null) {
                this.siteConfigList = result;
                this.isSkiptomainContent = result.isSkipMainContent;
            }
        });
    }

}
